// extracted by mini-css-extract-plugin
export default {"text":"ProgramFlashSale_text__PXOO9","programItems":"ProgramFlashSale_programItems__toV1k","btnContainer":"ProgramFlashSale_btnContainer__WX6Iu"};